import BillableItems from 'features/Invoice/BillableItems'
import InvoiceInstructions from 'features/Invoice/InvoiceInstructions'
import InvoiceSummaryCard from 'features/Invoice/InvoiceSummaryCard'
import MessagesTable from 'features/Invoice/MessagesTable'
import TotalCard from 'features/Invoice/TotalCard'

import styles from './Invoice.module.scss'
import InvoiceHeader from './InvoiceHeader'
import RevisionLink from './RevisionLink'

const SingleInvoice = ({
  invoiceDetails,
  taxRate = 9.5,
  messagesWithAdditionalCharges
}) => {
  return (
    <div className={styles.invoice} id="invoice">
      <div className={styles.pageOne}>
        <InvoiceHeader />
        <InvoiceSummaryCard invoiceDetails={invoiceDetails} />
        <InvoiceInstructions invoiceDetails={invoiceDetails} />
        <BillableItems invoiceDetails={invoiceDetails} />
        <TotalCard invoiceDetails={invoiceDetails} taxRate={taxRate} />
        <RevisionLink invoiceDetails={invoiceDetails}></RevisionLink>
      </div>
      {messagesWithAdditionalCharges?.details?.length > 0 && (
        <div className={styles.paymentDetails}>
          <h3 className={styles.freeTitle}>Billable messages</h3>
          <MessagesTable
            promotionTextsCost={invoiceDetails.usedCustomMessageCreditAmount}
            promotionTextsCount={invoiceDetails.usedCustomMessageCreditCount}
            totalAfterPromotion={messagesWithAdditionalCharges.totalAfterPromotion}
            items={messagesWithAdditionalCharges.details}
          />
        </div>
      )}
    </div>
  )
}

export default SingleInvoice
